import { useAdminPremiumSetupBanner } from '@ms/yammer-web-components/dist/adminPremiumSetupBanner';
import { useLeadershipCornerBanner } from '@ms/yammer-web-components/dist/leadershipCorner/LeadershipCornerBanner';
import Flex, { FlexItem } from '@ms/yammer-web-core-ui/dist/components/Flex';
import React, { useMemo } from 'react';

export const useGetBanners = () => {
  const adminPremiumSetupBanner = useAdminPremiumSetupBanner();
  const leadershipCornerBanner = useLeadershipCornerBanner();

  return useMemo(() => {
    const hasAnyBanner = adminPremiumSetupBanner || leadershipCornerBanner;
    const adminPremiumSetupBannerContent = adminPremiumSetupBanner ? (
      <FlexItem>{adminPremiumSetupBanner}</FlexItem>
    ) : null;
    const leadershipCornerBannerContent = leadershipCornerBanner ? <FlexItem>{leadershipCornerBanner}</FlexItem> : null;

    const renderContent = hasAnyBanner ? (
      <Flex grow={1} direction="column">
        {adminPremiumSetupBannerContent}
        {leadershipCornerBannerContent}
      </Flex>
    ) : null;

    return renderContent;
  }, [adminPremiumSetupBanner, leadershipCornerBanner]);
};
